import { render, staticRenderFns } from "./charities.vue?vue&type=template&id=3a81acc0&"
import script from "./charities.vue?vue&type=script&lang=js&"
export * from "./charities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports